import { useMutation } from '@tanstack/react-query';
import { deleteImagesFromFirebase } from '../api/deleteImagesFromFirebase.ts';

export const useDeleteImages = () => {
  return useMutation({
    mutationFn: deleteImagesFromFirebase,
  });
};
